<form [formGroup]="form" (ngSubmit)="onSubmit()" class="cargo__billing px-2 px-md-5">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
  <div class="cargo__billing__header">
    <h4 class="text-center text-strong">Facturación</h4>
    <div class="d-flex justify-content-center" *ngIf="transportNit">
      <app-transport-company-context [initialNit]="transportNit" [readonly]="true"></app-transport-company-context>
    </div>
    <hr>
    <div>
      <h5 class="text-center text-strong">Total a facturar ({{cargos.length}}):
        {{cargoListService.getTotalValueRateCargos(cargos) |
        currency:'COP':'code'}}</h5>
      <ul class="cargo__billing__list">
        <li *ngFor="let cargo of cargos;">
          <span class="text-strong">
            Servicio {{cargo.consecutive}}:
          </span>
          <span>
            {{cargoListService.getTotalValueRateCargo(cargo) | currency:'COP':'code'}}
          </span>
          <figure class="icon__bill" *ngIf="isBusinessCentralBilling; else siigoBill">
            <img src="assets/img/business-central.png" alt="Business Central">
          </figure>
          <ng-template #siigoBill>
            <figure class="icon__bill" *ngIf="hasSiigoIntegration">
              <img src="assets/img/logo_siigo.png" alt="Siigo">
            </figure>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>

  <div class="cargo__billing__body" *ngIf="isBillIntegration; else noBillIntegration">
    <!--Business-->
    <ng-container *ngIf="isBusinessCentralBilling; else commonBill">
      <mat-form-field appearance="standard" class="w-100">
        <mat-label>Producto<span class="asterisk">*</span></mat-label>
        <input type="text" matInput [formControl]="productControl" [matAutocomplete]="autoProduct">
        <mat-autocomplete #autoProduct="matAutocomplete" [displayWith]="displayProductSelected">
          <mat-option *ngFor="let productItem of listBillingProducts | async" [value]="productItem">
            {{ productItem.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="productControl.errors?.required || form.get('product').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="standard">
        <mat-label>Centro de Costo<span class="asterisk"
            *ngIf="utils.isRequiredField(form.get('costCenter'))">*</span></mat-label>
        <input type="text" #inputAutoComplete matInput [formControl]="costCenterControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCostCenterSelected">
          <mat-option *ngFor="let costCenter of listCostCenter | async" [value]="costCenter">
            {{costCenter.name}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('costCenter').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
      <!-- Business Central: solo los centros asociados a la empresa; sin catálogo general. -->
      <div *ngIf="companyCostCentersLoaded && !companyCostCenters.length" class="alert alert-info mt-2" role="alert">
        No hay centros de costo asociados a la empresa.
      </div>
      <mat-card-content>
        <mat-form-field appearance="standard" class="w-100">
          <mat-label>Observaciones</mat-label>
          <textarea matInput formControlName="observations"></textarea>
        </mat-form-field>
      </mat-card-content>
    </ng-container>
    <!--Siigo-->
    <ng-template #commonBill>
      <div *ngIf="!company?.billingConfiguration?.expirationDays" class="alert alert-warning" role="alert">
        <p class="mb-0">La empresa no tiene configurados los días acordados para el pago de facturas.</p>
        <p class="cursor-pointer text-bold underline mb-0"
          (click)="goToAdministrativeConfiguration('Configuración administrativa')">Si deseas puedes hacerlo aquí</p>
      </div>
      <div *ngIf="company?.billingConfiguration?.expirationDays" class="alert alert-info" role="alert">
        <p class="mb-0">{{company?.billingConfiguration?.expirationDays}} días configurados como plazo de pago para el
          pago de facturas</p>
      </div>
      <mat-form-field appearance="standard">
        <mat-label>Fecha de Vencimiento<span class="asterisk"
            *ngIf="utils.isRequiredField(form.get('dueDate'))">*</span></mat-label>
        <input type="text" matInput [matDatepicker]="datePicker" formControlName="dueDate" (click)="datePicker.open()"
          [min]="minDueDate" readonly>
        <mat-error *ngIf="form.get('dueDate').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="form.get('dueDate').errors?.matDatepickerMin">
          {{ DUE_DATE_MIN_MESSAGE }}
        </mat-error>
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="mt-2">
        <mat-label>Seleccione el vendedor</mat-label>
        <mat-select [formControl]="sellerControl">
          <mat-option *ngFor="let billingUser of listBillingUsers" [value]="billingUser">{{billingUser.firstName}}
            {{billingUser.lastName}} <span *ngIf="billingUser?.id === defaultSeller?.id"> (predeterminado) </span>
          </mat-option>
          <mat-option [value]="null" *ngIf="listBillingUsers?.length && canLoadMoreBillingUsers"
            (click)="getMoreBillingUsers()">Ver más ...</mat-option>
        </mat-select>
      </mat-form-field>
      <div
        *ngIf="sellerControl && sellerControl.value && sellerControl.value.id && defaultSeller?.id !== sellerControl?.value?.id"
        (click)="onChangeSeller()">
        <u class="text-bold cursor-pointer color-secondary-dark">Establecer este vendedor como predeterminado</u>
      </div>
      <div *ngIf="messageListBillingUsers" class="alert alert-danger" role="alert">
        {{messageListBillingUsers}}
      </div>

      <mat-form-field appearance="standard">
        <mat-label>Centro de Costo<span class="asterisk"
            *ngIf="utils.isRequiredField(form.get('costCenter'))">*</span></mat-label>
        <input type="text" #inputAutoComplete matInput [formControl]="costCenterControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCostCenterSelected">
          <mat-option *ngFor="let costCenter of listCostCenter | async" [value]="costCenter">
            {{costCenter.name}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('costCenter').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
      <div *ngIf="!(listCostCenter | async)?.length && !showAllCostCenters?.value"
        class="alert alert-info d-flex flex-column mt-2" role="alert">
        <span>No hay centros de costo asociados a la empresa. <span *ngIf="hasSiigoIntegration; else manualCostCenter"
            class="text-bold">Si deseas puedes asociar uno (recuerda que debe estar previamente creado en siigo)</span>
          <ng-template #manualCostCenter>
            <span>Si deseas puedes crear uno.</span>
          </ng-template></span>
        <button mat-raised-button type="button" color="primary"
          class="bg-color-primary button-width-auto text-bold cost-center-button mt-2"
          (click)="goToAdministrativeConfiguration('Centros de Costo')">
          <i class="fas fa-wrench hide-element mr-2"></i>
          <span>Configurar <span class="hide-element">centros de costo</span></span>
        </button>
      </div>

      <div class="w-100 d-flex justify-content-between align-items-baseline flex-wrap">
        <label class="text-strong">¿Mostrar todos los centros de costo?&nbsp;&nbsp;</label>
        <mat-button-toggle-group #group="matButtonToggleGroup" [formControl]="showAllCostCenters" class="h-auto m-0">
          <mat-button-toggle [value]="true" (change)="toggleListCostCenter()">
            Si
          </mat-button-toggle>
          <mat-button-toggle [value]="false" (change)="toggleListCostCenter()">
            No
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <mat-form-field appearance="standard" *ngIf="hasSiigoIntegration">
        <mat-label>Método de pago<span class="asterisk">*</span></mat-label>
        <mat-select formControlName="paymentType">
          <mat-option *ngFor="let payment of paymentTypes" [value]="{code: payment.id}" [disabled]="!payment.active">
            {{payment.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('paymentType').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>

      <mat-card-content>
        <mat-form-field appearance="standard">
          <mat-label>Observaciones</mat-label>
          <textarea matInput formControlName="observations"></textarea>
          <mat-error *ngIf="form.get('observations').errors?.maxlength">
            {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'observaciones', 50) }}
          </mat-error>
        </mat-form-field>
      </mat-card-content>

      <mat-form-field appearance="standard" *ngIf="!isBill && hasSiigoIntegration">
        <mat-label>
          Ingrese el Nº de Factura
          <span class="asterisk" *ngIf="utils.isRequiredField(form.get('billingId'))">*</span>
        </mat-label>
        <input matInput formControlName="billingId" type="text">
        <mat-error *ngIf="form.get('billingId').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>

      <div class="w-100 d-flex justify-content-between align-items-baseline flex-wrap mb-2">
        <label class="text-strong">¿Desea enviar reporte a la DIAN?&nbsp;&nbsp;</label>
        <mat-button-toggle-group #groupDian="matButtonToggleGroup" formControlName="sendDIAN" class="h-auto mx-0">
          <mat-button-toggle [value]="true">
            Si
          </mat-button-toggle>
          <mat-button-toggle [value]="false">
            No
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="w-100 d-flex justify-content-between align-items-baseline flex-wrap mb-2">
        <label class="text-strong">¿Desea notificar a los clientes por correo?&nbsp;&nbsp;</label>
        <mat-button-toggle-group #groupEmail="matButtonToggleGroup" formControlName="sendEmail" class="h-auto mx-0">
          <mat-button-toggle [value]="true">
            Si
          </mat-button-toggle>
          <mat-button-toggle [value]="false">
            No
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-template>
  </div>

  <ng-template #noBillIntegration>
    <div class="cargo__billing__body" *ngIf="!isBill && hasSiigoIntegration">
      <mat-form-field appearance="standard">
        <mat-label>
          Ingrese el Nº de Comprobante<span class="asterisk"
            *ngIf="utils.isRequiredField(form.get('billingId'))">*</span>
        </mat-label>
        <input matInput formControlName="billingId" type="text">
        <mat-error *ngIf="form.get('billingId').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
    </div>
  </ng-template>
  <div class="cargo__billing__footer">
    <mat-card-actions class="">
      <button type="button" mat-raised-button class="primary-secondary button-width-auto" color="primary"
        (click)="cancel()">
        Cancelar
      </button>
      <button type="submit" mat-raised-button color="primary" class="button-width-auto">
        Facturar
      </button>
    </mat-card-actions>
  </div>
</form>